module.exports = __webpack_public_path__ + "static/media/speedyg.efd0a189.jpg";